import styled from 'styled-components'

export const DividerComponent = styled.div<{
  width: string
  height: string
  color: string
}>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  background: ${({ color }) => color};
`
